import { useApiQuery } from 'src/api';
import { useBuildVars } from 'src/config';

export interface SearchACOPRequest {
  AcopTrackingNumber?: number;
  Bcn?: string;
  BidNumber?: string;
  BundleId?: string;
  IsOpenOrdersOnly?: boolean;
  OrderEndDate?: string;
  OrderNumber?: string;
  OrderStartDate?: string;
  ProgramId?: number;
  VendorId?: number;
}

export interface StatusCountResponse {
  activeStatuses: number;
  expiredStatuses: number;
  pendingStatuses: number;
  totalStatuses: number;
}

export function useGetStatusCount(params: SearchACOPRequest) {
  const buildVars = useBuildVars();
  return useApiQuery<StatusCountResponse>(
    '/system.webapi.gds/api/v1/gdsCoreApiDiscountMaintenance/GetDiscountStatusFilterCount',
    params,
    undefined,
    undefined,
    {
      host: buildVars.VP_API_BASE,
    }
  );
}
